module.exports = __webpack_public_path__ + "img/slide4-768.bc7e00dc.png";